// Import css files
import slick from '!!raw-loader!slick-carousel/slick/slick.css';
import slickTheme from '!!raw-loader!slick-carousel/slick/slick-theme.css';
import sass from '!!raw-loader!./asass.css';


export const oneStyle = slick + slickTheme + sass;
// + slick + slickΤheme + sass;

